import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { asyncInit } from '@/app/reducers/cartSlice';
import { asyncNoticeInit, setIsFreshLogin } from '@/app/reducers/noticeSlice';
import { asyncCompanyInit } from '@/app/reducers/companySlice';
import { asyncInitCommonMenus } from '@/app/reducers/menuSlice';
import { asyncUserInfo } from '@/app/reducers/headerSlice';

const initialState = {
  // 标记全局数据是否已初始化完成，防止重复调用 asyncAppReload
  initialized: false,
};

// 登录后/切换公司后统一初始化全局数据
// fresh=true: 真正登录/切换公司，会设置 isFreshLogin=true，弹 notice-summary
// fresh=false: 刷新页面自动登录，不弹 notice-summary
export const asyncAppReload = createAsyncThunk(
  'app/asyncAppReload',
  async (fresh = true, { dispatch }) => {
    if (fresh) dispatch(setIsFreshLogin(true));
    dispatch(asyncInit());
    dispatch(asyncNoticeInit());
    dispatch(asyncCompanyInit());
    dispatch(asyncInitCommonMenus());
    dispatch(asyncUserInfo());
  }
);

export const slice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    resetAppInitialized: (state) => {
      state.initialized = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(asyncAppReload.fulfilled, (state) => {
        state.initialized = true;
      });
  },
});

const { reducer, actions } = slice;
export const { resetAppInitialized } = actions;
export default reducer;